export const DEFAULT_VIDEO_MODEL = {
    name: 'seedance-2.5',
    actionTag: 'seedance2.5',
} as const

export const DEFAULT_FILM_MODEL = {
    name: 'minimax-h3-max',
    actionTag: 'h3max',
    durationSeconds: 15,
} as const
